
_vcMQ_TriggerName = '_VCMQ_MSG';

function vcMQ() { this.consumer = []; }
vcMQ.prototype.addConsumer = function (vcgid) {
 


    var found = false;
    for (var i = 0; i < this.consumer.length; i++) {
        if ((this.consumer[i].vcgid === vcgid)) { found = true}
    }
    if (found === false) { this.consumer.push({ 'vcgid': vcgid, 'visual': null, 'fnc_callback': [] }) };
}

vcMQ.prototype.consume = function (visual, vcgid, fnc_callback) {
    var i;
    for (i = 0; i < this.consumer.length; i++) {
        if ((this.consumer[i].vcgid === vcgid) || (this.consumer[i].vcgid + 'FS' === vcgid)) {
            if (this.consumer[i].visual==null) {
                this.consumer[i].visual = visual;
            } else {
                if (this.consumer[i].visual[0] === visual[0]) {
                    this.consumer[i].visual = visual;
                } else {
                    this.consumer[i].fnc_callback = [];
                }
            }
            this.consumer[i].fnc_callback.push(fnc_callback);
        }
    }
    $(document).off(_vcMQ_TriggerName);
    for (i = 0; i < this.consumer.length; i++) {
        if (this.consumer[i].visual != null) {
            for (var j = 0; j < this.consumer[i].fnc_callback.length; j++) {
               this.consumer[i].visual.consumer(this.consumer[i].fnc_callback[j]);
            }
        }
    }
  //  console.info(jQuery._data(document, "events")._VCMQ_MSG);
}

vcMQ.prototype.produce = function (e, vcgid, msg, values) {
    var event = jQuery.Event(_vcMQ_TriggerName);
    event.vcgid = vcgid;
    event.msg = msg;
    event.values = values;
    e.trigger(event);
  
}

var _VCMQ = new vcMQ();
$.fn.consumer = function (callback) {
    return this.each(function () {
        var el = this;
        $(document).on(_vcMQ_TriggerName, function() {
            callback.apply(el, arguments);
        });
    });
}
